var idResize; //for resize-timer
var windowsWidth = jQuery(window).outerWidth();
let movement = "";
let oldx = 0;
let oldy = -1;
var scroll_start = 0;
var startchange = jQuery(".entry-content")[0];
var startchangeOffsetTop = typeof (startchange) != 'undefined' ? startchange.offsetTop + 0 : 0;
let navbarToggler = jQuery(".navbar-toggler")[0];
/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
function handleHasHiddenTextToggleClassClicked(caller = null) {
  let actionContainers = jQuery(".action-click-container .action-container .action-one");
  let actionContainersLength = actionContainers.length;
  let i = 1;
  let changedClass = false;
  if (!actionContainersLength) {
    actionContainersLength = 0;
  }
  if (actionContainersLength > 0) {
    Object.keys(actionContainers).forEach(actionContainer => {
      if (i > Number(actionContainersLength)) {
        return;
      }
      // let hiddenTextContainer = jQuery(actionContainers[actionContainer]).closest('.has-hidden-text');
      if (jQuery(actionContainers[actionContainer]).hasClass('show')) {
        jQuery(actionContainers[actionContainer]).removeClass('show');
        if (caller == actionContainers[actionContainer]) {
          changedClass = true;
        }
      }
      i++;
    });
  }
  return changedClass;
}
function zw_toggle_mega_menu(menuitem, closestA) {
  // jQuery('.main-header').addClass('zw-flow-none');
  console.debug('MENU TOGGLED!!!!')
  closestA = menuitem.closest(".menu-item-has-children")[0].firstChild;
  let closestAInnerText = closestA.innerHTML;
  let closestAHref = jQuery(closestA).attr("href");
  // console.log(closestAHref)
  let parentUL = jQuery(menuitem).parent().parent();
  let parentLI = jQuery(menuitem).parent();
  let nextLvlUl = jQuery(menuitem).siblings(".dropdown-menu");
  // nextLvlUl[0].children[0].innerHTML = closestAInnerText;
  // console.log("nextLvlUl[0].children[0].innerHTML", nextLvlUl[0].children[0].innerHTML)
  nextLvlUl[0].children[0].innerHTML =
    '<span class="back-icon" onclick="zw_toggle_mega_menu_back(jQuery(this))"></span><span class="back-button" ><a href="' +
    closestAHref +
    '">' +
    closestAInnerText +
    "</a></span>";
  jQuery(nextLvlUl).toggleClass("d-flex");
  jQuery(parentUL).toggleClass("invisible");
  jQuery(parentLI).toggleClass("menu-active");
  jQuery(nextLvlUl).toggleClass("visible");

  if (jQuery(menuitem).parent().parent().hasClass("dropdown-menu")) {
    jQuery(menuitem)
      .parent()
      .parent()
      .children(".backtext")
      .toggleClass("d-none");
  }
}

window.zw_toggle_mega_menu = zw_toggle_mega_menu;

function zw_toggle_mega_menu_back(menuitem) {
  // jQuery('.main-header').removeClass('zw-flow-none');
  console.debug('MENU TOGGLED BACK!!!!')
  menuitem = jQuery(menuitem).closest(".backtext");
  var parentUL = jQuery(menuitem).parent();
  // zw_main_menu_same_height(parentUL);
  jQuery(menuitem)
    .parents("ul")
    .find(".backtext")
    .each(function () {
      if (jQuery(this).hasClass("d-none")) {
        jQuery(this).removeClass("d-none");
      }
    });
  jQuery(parentUL).toggleClass("d-flex");
  // var parentULwithNullHeight = parentUL.parent().parent('ul.null-height');
  // jQuery(parentULwithNullHeight).toggleClass('null-height');
  var parentULwithNullHeight = parentUL.parent().parent("ul.invisible");
  jQuery(parentULwithNullHeight).toggleClass("invisible");
  jQuery(parentUL).toggleClass("visible");
  jQuery(parentUL).parent().toggleClass("menu-active");
}

window.zw_toggle_mega_menu_back = zw_toggle_mega_menu_back;

/**
 * Make Main Menu drop-down ul same height
 */

function zw_main_menu_same_height(startElemente) {
  var outerHeight = jQuery("#main-menu").outerHeight();
  var curHeight = jQuery(startElemente).outerHeight();

  if (curHeight > outerHeight) {
    jQuery("#main-menu").css("height", curHeight + "px");
    outerHeight = curHeight;
  }
  var padding = outerHeight - curHeight;
  var calcString =
    "calc(" +
    jQuery(startElemente).css("padding-bottom") +
    " + " +
    padding +
    "px)";

  jQuery(startElemente).css("padding-bottom", calcString);
  jQuery(startElemente).css({
    height: outerHeight + "px",
    width: "100%",
  });
}

window.zw_main_menu_same_height = zw_main_menu_same_height;

/* Scroll to anchor */
function pgshow(e) {
  var elId = window.location.hash;
  if (elId.length > 1) {
    let el = document.getElementById(elId.substr(1));
    if (el) el.scrollIntoView(true);
  }
}
window.pgshow = pgshow;

// pageshow fires after load and on Back/Forward
window.addEventListener("pageshow", pgshow);

function stickyAnimation() {
  // setTimeout(() => { r.style.setProperty('--zw-opacity-sticky-btn', '1') }, 2000);
  var r = document.querySelector(":root");

  function animation() {
    // 10 sec then play animation // nach 2 play naimaton // 4 sec return no animation
    setTimeout(() => {
      r.style.setProperty("--zw-opacity-sticky-btn", "0");

      setTimeout(() => {
        r.style.setProperty("--zw-opacity-sticky-btn", "1");
        setTimeout(() => {
          animation();
        }, 2000);
      }, 2000);
    }, 4000);
  }
  animation();
}

function zw_archive_filter_init() {
  // Select the filters and elements for the archive filter functionality
  const filters = jQuery('.zw-archive .searchfield .zw-field');
  const elements = jQuery('.zw-archive .zw-filter-content .zw-filter-item');
  const errorMessage = jQuery('.zw-archive .errorFilterMessage');

  // Attach an event listener for change events on the filters
  jQuery(filters).on("change", function () {
    let selectedValues = [];

    // Iterate through each filter to collect selected values
    jQuery(filters).each(function (index) {
      var selected = jQuery(this).find(":selected").val();
      if (selected != '') // If the selected value is not empty, push it to the selectedValues array
      {
        selectedValues.push(Number(selected));
      }
    });

    // console.debug('Selected Values: ', selectedValues); 

    let foundSome = false;
    let allPossibleTerms = [];

    // Iterate through each element and apply the filter logic
    jQuery(elements).each(function () {
      let termIdArray = JSON.parse(jQuery(this).attr('data-zw-terms')); // Parse the term IDs
      var i;
      let noMatch = false;

      // console.debug("termIdArray", termIdArray) 

      // Logic to check if all selected values match the termIdArray
      let checker = (arr, target) => target.every(v => arr.includes(v));
      if (checker(termIdArray, selectedValues)) {
        jQuery(this).removeClass('d-none');
        // jQuery(this).addClass('d-flex');
        noMatch = true;
        foundSome = true;
        allPossibleTerms.push(...termIdArray);
      }

      if (noMatch === false) // If no match, hide the element
      {
        // jQuery(this).removeClass('d-flex');
        jQuery(this).addClass('d-none');
      }
    });

    allPossibleTerms = [...new Set(allPossibleTerms)]; // Remove duplicates from allPossibleTerms
    // console.debug('allPossibleTerms', allPossibleTerms); 

    // Iterate through each filter to enable/disable options based on the terms
    jQuery(filters).each(function () {
      // console.debug('select: ', this); // Debugging statement to show the filter select element
      const options = Array.from(this.options);
      let doContinue = true;

      // If only one value is selected, check if the entire selectbox should be enabled
      if (selectedValues.length === 1) {
        options.forEach((option) => {
          if (selectedValues.includes(Number(option.value))) {
            doContinue = false;
          }
        });
      }

      // Enable or disable options based on matching terms
      if (doContinue) {
        options.forEach((option) => {
          if (allPossibleTerms.includes(Number(option.value)) || option.value == "") {
            option.disabled = false;
          } else {
            option.disabled = true;
          }
        });
      } else // enable entire selectbox
      {
        options.forEach((option) => {
          option.disabled = false;
        });
      }
    });

    // Show or hide the error message based on whether any elements were found
    if (foundSome) {
      jQuery(errorMessage).removeClass('d-block');
      jQuery(errorMessage).addClass('d-none');
    } else {
      jQuery(errorMessage).removeClass('d-none');
      jQuery(errorMessage).addClass('d-block');
    }
  });
}


function handle_archive_filter_zw_selects() {
  // Select the filters and elements for the archive filter functionality
  const filters = jQuery('.zw-archive .searchfield .dropdown-menu');
  const elements = jQuery('.zw-archive .zw-filter-content .zw-filter-item');
  const errorMessage = jQuery('.zw-archive .errorFilterMessage');

  let selectedValues = [];
  // Iterate through each filter to collect selected values
  jQuery(filters).each(function (index) {
    var selected = this.dataset['selected'];
    if (selected != '') // If the selected value is not empty, push it to the selectedValues array
    {
      selectedValues.push(Number(selected));
    }
  });

  // console.debug('Selected Values: ', selectedValues); 

  let foundSome = false;
  let allPossibleTerms = [];

  // Iterate through each element and apply the filter logic
  jQuery(elements).each(function () {
    let termIdArray = JSON.parse(jQuery(this).attr('data-zw-terms')); // Parse the term IDs
    var i;
    let noMatch = false;

    // console.debug("termIdArray", termIdArray) 

    // Logic to check if all selected values match the termIdArray
    let checker = (arr, target) => target.every(v => arr.includes(v));
    if (checker(termIdArray, selectedValues)) {
      jQuery(this).removeClass('d-none');
      // jQuery(this).addClass('d-flex');
      noMatch = true;
      foundSome = true;
      allPossibleTerms.push(...termIdArray);
    }

    if (noMatch === false) // If no match, hide the element
    {
      // jQuery(this).removeClass('d-flex');
      jQuery(this).addClass('d-none');
    }
  });

  allPossibleTerms = [...new Set(allPossibleTerms)]; // Remove duplicates from allPossibleTerms
  // console.debug('allPossibleTerms', allPossibleTerms); 

  // Iterate through each filter to enable/disable options based on the terms
  jQuery(filters).each(function () {
    // console.debug('select: ', this); // Debugging statement to show the filter select element
    const options = Array.from(this.childNodes);
    let doContinue = true;

    // If only one value is selected, check if the entire selectbox should be enabled
    if (selectedValues.length === 1) {
      options.forEach((option) => {
        const value = jQuery(option).data('value');
        if (selectedValues.includes(Number(value))) {
          doContinue = false;
        }
      });
    }
    // console.debug('selectedValues', selectedValues);
    // console.debug('allPossibleTerms', allPossibleTerms);
    // Enable or disable options based on matching terms
    if (doContinue) {
      options.forEach((option) => {
        const value = jQuery(option).data('value')
        if (allPossibleTerms.includes(Number(value)) || value == "") {
          // option.disabled = false;
          jQuery(option).removeClass('disabled');
        } else {
          // option.disabled = true;
          jQuery(option).addClass('disabled');
        }
      });
    } else // enable entire selectbox
    {
      options.forEach((option) => {
        // option.disabled = false;
        jQuery(option).removeClass('disabled');
      });
    }
  });

  // Show or hide the error message based on whether any elements were found
  if (foundSome) {
    jQuery(errorMessage).removeClass('d-block');
    jQuery(errorMessage).addClass('d-none');
  } else {
    jQuery(errorMessage).removeClass('d-none');
    jQuery(errorMessage).addClass('d-block');
  }
}

function addClickListenerToCustomSelectOptions() {
  jQuery('.zw-select .dropdown-menu li').click(function () {
    this.closest('.zw-select').querySelector('.zw-field-custom').innerText = this.innerText;

    this.closest('.zw-select').querySelector('.dropdown-menu').dataset['selected'] = this.dataset['value'];
    handle_archive_filter_zw_selects();
  })
}

function addClickListenerToClearFilterButton() {
  jQuery('.zw-reset-filter-button').click(function () {

    const filters = jQuery('.zw-archive .searchfield .dropdown-menu');
    jQuery(filters).each(function (index) {
      this.closest('.zw-select').querySelector('.zw-field-custom').innerText = this.children[0].innerHTML;
      this.dataset['selected'] = '';
      handle_archive_filter_zw_selects();
    });
  })
}

function observeChangeInMobileNavClassList() {
  // Select the element you want to observe
  const targetElement = document.querySelector('#mainmenutoggler');

  // Create an observer instance
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const hasShowClass = mutation.target.classList.contains('show');

        if (hasShowClass) {
          jQuery('body').addClass('zw-show-mobile');
          // Add any other actions when .show is added
          // zw_toggle_mega_menu();
        } else {
          jQuery('body').removeClass('zw-show-mobile');
          // Add any other actions when .show is removed
          // zw_toggle_mega_menu_back();
        }
      }
    });
  });

  // Configuration of the observer (listen to changes in attributes, specifically the class attribute)
  const config = {
    attributes: true, // Observe attribute changes
    attributeFilter: ['class'] // Only listen for class attribute changes
  };

  // Start observing the target element
  observer.observe(targetElement, config);

  // To stop observing at some point, you can use:
  // observer.disconnect();
}


jQuery(document).ready(function () {
  window.setTimeout(() => {
    //listen for class change in mobile nav
    // disabled the function below - it is wating for the document ready which is a bit late and made a new observer on the line 914
    // observeChangeInMobileNavClassList();

    // Initialize essential variables outside of the scroll handlers to avoid repeated calculations.
    const windowsWidth = jQuery(window).width();
    const mainHeader = jQuery(".main-header");
    let scrollStart = 0;
    let startChangeOffsetTop = Math.max(
      0,
      parseInt(mainHeader.data("offset-top"), 10) || 0
    );

    // Function to toggle sticky class based on scroll position.
    function toggleStickyHeader() {
      let scrollStart = jQuery(window).scrollTop();
      if (scrollStart > startChangeOffsetTop) {
        mainHeader.addClass("sticky");
      } else {
        if (
          windowsWidth < 1250 &&
          !jQuery("#mainmenutoggler").hasClass("show")
        ) {
          mainHeader.removeClass("sticky");
        } else if (windowsWidth >= 1250) {
          mainHeader.removeClass("sticky");
        }
      }
    }
    window.toggleStickyHeader = toggleStickyHeader;

    // Call the function once initially and bind it to scroll events.
    toggleStickyHeader();
    jQuery(window).scroll(toggleStickyHeader);

    // Sticky header and action handling for different window widths.
    // stickyAnimation();
    // Handling social share toggler clicks.
    // jQuery('body').on('click', '.zw-social-share .zw-social-share-toggler', function (e)
    // {
    //     e.preventDefault();
    //     let $currentTarget = jQuery(e.currentTarget);
    //     let ariaStatus = $currentTarget.attr('aria-expanded') === 'false';
    //     $currentTarget.attr('aria-expanded', ariaStatus ? 'true' : 'false');
    //     $currentTarget.parents('.zw-social-share').find('.zw-share-dropdown-menu').toggleClass('show');
    // });

    // Mutation observer for navbar toggler changes.
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        switch (mutation.type) {
          case "attributes":
            switch (mutation.attributeName) {
              case "aria-expanded":
                scroll_start = jQuery(this).scrollTop();
                if (startchangeOffsetTop < 0) {
                  startchangeOffsetTop = 0;
                }
                if (
                  mutation.target.attributes["aria-expanded"].value == "true"
                ) {
                  jQuery(".main-header").addClass("aria-class");
                } else if (scroll_start <= startchangeOffsetTop) {
                  jQuery(".main-header").removeClass("aria-class");
                }
                break;
            }
            break;
        }
      });
    });

    // Assuming navbarToggler is defined correctly elsewhere in your script.
    if (typeof (navbarToggler) != 'undefined') {
      observer.observe(navbarToggler, {
        attributes: true,
        subtree: true,
        childList: true,
        attributeFilter: ["aria-expanded"],
      });
    }


    // Hide navigation on item click.
    jQuery("#main-menu .dropdown-item, #main-menu .nav-link").on(
      "click",
      function () {
        jQuery(".navbar-collapse").collapse("hide");
      }
    );
  }, 0);

  //sticky iconc click handler 
  zw_archive_filter_init();
  //selectOptionsClickHandler
  addClickListenerToCustomSelectOptions();
  addClickListenerToClearFilterButton();
  jQuery(".action-click-container .action-container .action-one").click(function (e) {
    if (jQuery(this).hasClass("show")) {
      return;
    }
    const changedClass = handleHasHiddenTextToggleClassClicked(this);
    if (!changedClass) {
      jQuery(this).toggleClass('show');
    }
  });
});

/**
 * On Resize
 */
jQuery(window).resize(function () {
  let windowsWidth = jQuery(window).outerWidth();
  if (windowsWidth >= 1250) {
    /**
     * REMOVE ALL CLASSES FROM OPEN MEGA MENU MOBILE to enable desktop hover menu on resize
     */
    if (jQuery("#main-menu").hasClass("invisible")) {
      jQuery("#main-menu").removeClass("invisible");
    }

    if (jQuery("#mainmenutoggler").hasClass("show")) {
      jQuery("#mainmenutoggler").removeClass("show");
    }

    if (jQuery(".main-header").hasClass("sticky")) {
      jQuery(".sticky").removeClass("sticky");
    }
    jQuery("#main-menu .dropdown-menu.megamenu").each(function () {
      if (jQuery(this).hasClass("d-flex")) {
        jQuery(this).removeClass("d-flex");
      }
      if (jQuery(this).hasClass("visible")) {
        jQuery(this).removeClass("visible");
      }
      if (jQuery(this).hasClass("invisible")) {
        jQuery(this).removeClass("invisible");
      }
    });
  }

  /* this document */
});

jQuery(document).click(function () {
  let container = jQuery(".action-click-container .action-container");
  if (!container.is(event.target) && !container.has(event.target).length) {
    handleHasHiddenTextToggleClassClicked();
  }
});

// Hide the dropdown on scroll
window.addEventListener("scroll", function () {
  const dropdowns = document.querySelectorAll(".desktop .menu-item-has-children .dropdown-menu");

  dropdowns.forEach(function (dropdown) {
    dropdown.style.display = "none";
  });
});

// Show dropdown on hover
document.querySelectorAll(".desktop .menu-item-has-children").forEach(function (menuItem) {
  menuItem.addEventListener("mouseenter", function () {
    const dropdown = this.querySelector(".dropdown-menu");
    if (dropdown) {
      dropdown.style.display = "flex"; // Show the dropdown on hover
    }
  });

  menuItem.addEventListener("mouseleave", function () {
    const dropdown = this.querySelector(".dropdown-menu");
    if (dropdown) {
      dropdown.style.display = "none"; // Hide the dropdown when the mouse leaves
    }
  });
});

///////////////////////////////////////////////////////////////////////////////////////////
// Remove focusability from hidden content - start
function updateTabIndexForSlide(slider) {
  if (!slider) {
    return;
  }
  //TODO: not the best solution but it works it is what it is
  setTimeout(() => {
    slider.find('.slick-slide').each(function() {
      const $slide = jQuery(this);
      const isHidden = $slide.attr('aria-hidden') === 'true';
      const index = $slide.data('slick-index');
      
      if (isHidden) {
        $slide.attr('tabindex', '-1');
        // $slide.attr('FLQM', '-1');
        // console.log(`Slide ${index} is hidden → tabindex set to -1.`);
      } else {
        $slide.attr('tabindex', '0');
        // $slide.attr('FLQM', '0');
        // console.log(`Slide ${index} is visible → tabindex set to 0.`);
      }
    });
  }, 300);
}

var $fullPageSlider = jQuery('.multiple-items');
var $dynamicPostsSlider = jQuery('.multiple-items.slick-initialized.slick-slider');

//handler for tab indexes on init 
$fullPageSlider.on('init', () => updateTabIndexForSlide($fullPageSlider));
$dynamicPostsSlider.on('init', () => updateTabIndexForSlide($dynamicPostsSlider));

//handler for tab indexes on after change
$fullPageSlider.on('afterChange', () => updateTabIndexForSlide($fullPageSlider));
$dynamicPostsSlider.on('afterChange', () => updateTabIndexForSlide($dynamicPostsSlider));

jQuery(document).ready(function($) {
    jQuery('.slick-slider').on('init', function(event, slick) {
      jQuery('.slick-slide a').each(function() {
        const $link = jQuery(this);
        const tabindex = $link.attr('tabindex');
  
        if (tabindex === '0') {
          $link.attr('aria-hidden', 'false');
        } else if (tabindex === '-1') {
          $link.attr('aria-hidden', 'true');
        }
  
        console.log('Link found:', this, 'Tabindex:', tabindex);
      });
    });
  
    // If slick is already initialized, trigger the function immediately
    if (jQuery('.slick-slider').hasClass('slick-initialized')) {
        jQuery('.slick-slide a').each(function() {
        const $link = jQuery(this);
        const tabindex = $link.attr('tabindex');
  
        if (tabindex === '0') {
          $link.attr('aria-hidden', 'false');
        } else if (tabindex === '-1') {
          $link.attr('aria-hidden', 'true');
        }
  
        console.log('Link found (immediate):', this, 'Tabindex:', tabindex);
      });
    }
});
// Remove focusability from hidden content - end

//listen for class change in mobile nav
document.addEventListener('DOMContentLoaded', function () {
  // Select the navbar toggler button
  const toggler = document.querySelector('.header__navbar-toggler');

  if (!toggler) return; // Safety check

  // Create the observer
  const observer = new MutationObserver(function (mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
        const isExpanded = toggler.getAttribute('aria-expanded') === 'true';
        document.body.classList.toggle('zw-show-mobile', isExpanded);
      }
    }
  });

  // Start observing aria-expanded changes
  observer.observe(toggler, { attributes: true, attributeFilter: ['aria-expanded'] });
});